import { FC, useCallback } from 'react'
import { BookmarkButtonWrapper } from './styles'
import BookmarkIcon from 'shared/assets/32/BookmarkIcon'
import BookmarkIcon32Fill from 'shared/assets/32/BookmarkIcon32Fill'
import { CurrentProjectActions, CurrentProjectSelector } from 'shared/reducers/CurrentProject'
import { useTranslation } from 'react-i18next'
import { useToasts } from '@brg/ui'
import { useDispatch, useSelector } from 'react-redux'
import { BookmarkAPI } from '@brg/api'
import { useProfile } from '@brg/auth'

interface BookmarkButtonProjectPageProps {
  entityType: string;
  entityId: string;
};


export const BookmarkButtonProjectPage: FC<BookmarkButtonProjectPageProps> = ({entityId, entityType}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const dispatch = useDispatch();
  const profile = useProfile()

  const bookmarkedLocally = useSelector(CurrentProjectSelector)?.projectStatus?.[entityId]?.isBookmarked;

  const setLocalStatus = (status: boolean) => {
    dispatch(CurrentProjectActions.setBookmarked({id: entityId, status }));
  }

  const handleBookmarkClick = useCallback(() => {
    
    const method = bookmarkedLocally ? 'RemoveBookmark' : 'Bookmark'
    BookmarkAPI[method]({ entityId, entityType })
      .then(() => {
        setLocalStatus(!bookmarkedLocally);
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      })
  }, [bookmarkedLocally, t, entityId, entityType, toasts]);

  if (!profile) return <></>

  return (
    <BookmarkButtonWrapper mobilePosition='absolute' isProjectPage onClick={handleBookmarkClick}>
      {
      bookmarkedLocally ? 
        <BookmarkIcon32Fill fill='#fff'/> :
        <BookmarkIcon fill='#fff'/>
      }
    </BookmarkButtonWrapper>
  )
}
import { FC, useCallback } from 'react'
import { BookmarkButtonWrapper } from './styles'
import BookmarkIcon from 'shared/assets/32/BookmarkIcon'
import BookmarkIcon32Fill from 'shared/assets/32/BookmarkIcon32Fill'
import { CurrentProjectActions, CurrentProjectSelector } from 'shared/reducers/CurrentProject'
import { useTranslation } from 'react-i18next'
import { useToasts } from '@brg/ui'
import { useDispatch, useSelector } from 'react-redux'
import { BookmarkAPI } from '@brg/api'
import { useProfile } from '@brg/auth'

interface BookmarkButtonProjectPageProps {
  entityType: string;
  entityId: string;
};


export const BookmarkButtonProjectPage: FC<BookmarkButtonProjectPageProps> = ({entityId, entityType}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const dispatch = useDispatch();
  const profile = useProfile()

  const bookmarkedLocally = useSelector(CurrentProjectSelector)?.projectStatus?.[entityId]?.isBookmarked;

  const setLocalStatus = (status: boolean) => {
    dispatch(CurrentProjectActions.setBookmarked({id: entityId, status }));
  }

  const handleBookmarkClick = useCallback(() => {
    
    const method = bookmarkedLocally ? 'RemoveBookmark' : 'Bookmark'
    BookmarkAPI[method]({ entityId, entityType })
      .then(() => {
        setLocalStatus(!bookmarkedLocally);
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      })
  }, [bookmarkedLocally, t, entityId, entityType, toasts]);

  if (!profile) return <></>

  return (
    <BookmarkButtonWrapper mobilePosition='absolute' isProjectPage onClick={handleBookmarkClick}>
      {
      bookmarkedLocally ? 
        <BookmarkIcon32Fill fill='#fff'/> :
        <BookmarkIcon fill='#fff'/>
      }
    </BookmarkButtonWrapper>
  )
}
